var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4092 6.72177L18.5816 3.68074C18.1774 3.24603 17.617 3 17.0309 3H6.96913C6.38304 3 5.82257 3.24603 5.41837 3.68074L2.59077 6.72177C1.84825 7.52033 1.80001 8.7594 2.47809 9.61598L11.1683 20.594C11.5968 21.1353 12.4032 21.1353 12.8317 20.594L21.5219 9.61598C22.2 8.75939 22.1517 7.52033 21.4092 6.72177Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondShape);
export default __webpack_public_path__ + "static/media/diamond-shape.1223ac44951911e38aaa4642e4468bd7.svg";
export { ForwardRef as ReactComponent };